export default __webpack_public_path__ + "images/1_Hele_MENY.jpeg";